import axios from "axios";


export const getPendingJobs = async () => {
  try {
    const response = await axios.get("/dashboard/pending-jobs");
    console.log("Pending Jobs", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching jobs:", error.message);
    throw error;
  }
};

export const getAllJobs = async () => {
  try {
    const response = await axios.get("/dashboard/all-jobs");
    console.log(response.data, "All Jobs");
    return response.data;
  } catch (error) {
    console.error("Error fetching jobs:", error.message);
    throw error;
  }
};

export const getPendingPayments = async () => {
  try {
    const response = await axios.get("/dashboard/pending-payments");
    console.log(response.data, "total outstanding");
    return response.data;
  } catch (error) {
    console.error("Error fetching jobs:", error.message);
    throw error;
  }
};
export const getPaidPayments = async () => {
  try {
    const response = await axios.get("/dashboard/paid");
    console.log(response.data, "JOB JOB DATA API");
    return response.data;
  } catch (error) {
    console.error("Error fetching jobs:", error.message);
    throw error;
  }
};

export const getAllCounts = async () => {
  try {
    const response = await axios.get(
      `/dashboard/get-counts`
    );
    //console.log("All Counts:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching counts:", error.message);
    
  }
};

export const getMonthlyCounts = async (year) => {
  try {
    const response = await axios.get(
      `/dashboard/sales-purchase-counts?year=${year}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching montly purchase sales counts:",
      error.message
    );
    throw error;
  }
};

export const getAllInvoiceByPaidMethod = async (params) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.status) queryParams.append('status', params.status);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.search) queryParams.append('search', params.search);

    const response = await axios.get(
      `/dashboard/invoices-by-status?${queryParams.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching invoices by status:",
      error.message
    );
    throw error;
  }
};

export const getDonutChartData = async (year, month) => {
  try {
    let params = '';
    if (year) params += `year=${year}`;
    if (month) params += `${params ? '&' : ''}month=${month}`;
    const response = await axios.get(`/dashboard/donut-chart${params ? '?' + params : ''}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching donut chart data:", error.message);
    throw error;
  }
};

export const getSalesAndCashflow = async (year) => {
  try {
    const response = await axios.get(`/dashboard/sales-cashflow?year=${year}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching sales and cashflow data:", error.message);
    throw error;
  }
};

export const getExpensesBreakdown = async (year, month) => {
  try {
    let params = '';
    if (year) params += `year=${year}`;
    if (month) params += `${params ? '&' : ''}month=${month}`;
    const response = await axios.get(`/dashboard/expenses-breakdown${params ? '?' + params : ''}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching expenses breakdown:", error.message);
    throw error;
  }
};

export const getOutstandingInvoices = async (limit = 10) => {
  try {
    const response = await axios.get(`/dashboard/outstanding-invoices?limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching outstanding invoices:", error.message);
    throw error;
  }
};
